import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { LoaderHide, LoaderShow } from '../../state/loader/loader.actions';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  constructor(private store: Store) {
  }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.store.dispatch(new LoaderShow('indeterminate'));

    return next.handle(req).pipe(
      tap((ev: HttpEvent<any>) => {
        // Not an HTTP response
        if (!(ev instanceof HttpResponse)) {
          return;
        }

        this.store.dispatch(new LoaderHide());
      }),
      catchError((err, caught) => {
        this.store.dispatch(new LoaderHide());

        return throwError(err);
      })
    );
  }

}
